export default __webpack_public_path__ + "static/uhc-colorful-aa05910f6d91dbdcd6c5ed064124d142.svg";